module.exports = __webpack_public_path__ + "static/media/marcoVerde.a4f02aa2.svg";